import { Image, SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  margin: 1rem;
`;

export const StyledImageWrapper = styled.div<{ itemCount: number }>`
  align-items: center;
  display: grid;
  gap: 1rem;
  grid-template-columns: ${({ itemCount }) => (itemCount <= 3 ? `repeat(${itemCount}, 1fr)` : 'repeat(3, 1fr)')};
  grid-template-rows: ${({ itemCount }) => (itemCount > 3 ? `repeat(${Math.ceil(itemCount / 3)}, auto)` : 'auto')};
  justify-items: center;
  margin: 3rem auto;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    max-width: 60%;
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    max-width: 60%;
  }
`;

export const StyledImage = styled(Image)`
  height: 4.75rem;
  object-fit: contain;
  padding: inherit;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    height: 8.75rem;
  }
`;

export const StyledWrapper = styled(SpacerWrapper)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    align-items: center;
    flex-direction: row;
  }
`;
